import { getSiteConfig } from '@shared/config';
import { CopyrightAndSocialsSection } from '../Footer/CopyrightAndSocialsSection/CopyrightAndSocialsSection';
import { Divider } from '../Footer/Divider/Divider';
import { UnderageSection } from '../Footer/UnderageSection/UnderageSection';

function SimplifiedFooter() {
  const {
    footerConfig: { underageSection, copyrightAndSocials },
  } = getSiteConfig();

  return (
    <footer id="footer" role="contentinfo" className="bg-container-base py-6 border-t-4 border-t-accent-green ll-grid-container" data-track-section="Footer">
      <div className="ll-container-inner">
        {underageSection ? (
          <>
            <UnderageSection config={underageSection} />
            {copyrightAndSocials ? <Divider /> : null}
          </>
        ) : null}
        {copyrightAndSocials ? <CopyrightAndSocialsSection config={copyrightAndSocials} /> : null}
      </div>
    </footer>
  );
}

export { SimplifiedFooter };
